import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllBanks = ({ marvarApi, dispatch, onLogout }) => {

    // 1. Para los datos recuperados de la BD
    const [dataBanks, setDataBanks] = useState([])

    // 2. Para mostrar animación de carga
    const [loadingFetchAllBanks, setLoadingFetchAllBanks] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(0)
    const executeFetch = async () => {
        setExecute(execute + 1)
    }

    const fetchData = async () => {

        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {

            const response = await marvarApi.get(`/banco`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllBanks(true)
        fetchData()
            .then((resp) => {
                setDataBanks(resp.data)
                setLoadingFetchAllBanks(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllBanks(false)
            })
    }, [execute])

    return { dataBanks, loadingFetchAllBanks, executeFetch }

}

export const useFetchSpecificBank = ({ marvarApi, dispatch, onLogout, Forms }) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen

    // 2. Para mostrar animación de carga
    const [loadingFetchSpecificBank, setLoadingFetchSpecificBank] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({ idbanco: '' })

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(0)
    const executeFetch = async () => {
        setExecute(execute + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {

            const response = await marvarApi.get(`/banco/${paramsToSearch.idbanco}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.idbanco > 0) {
            setLoadingFetchSpecificBank(true)
            fetchData()
                .then((resp) => {
                    // Setea en el estado del formulario los datos del registro
                    setFormState((prevState) => ({
                        ...prevState,
                        idbank: resp.data[0].idbanco || '',
                        name: resp.data[0].nombre || '',
                        currency_type: resp.data[0].currency_type || 'QUETZAL',
                        state: resp.data[0].estado || ''
                    }))
                    setLoadingFetchSpecificBank(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificBank(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificBank, setParamsToSearch, executeFetch }

}